import { gql } from "@apollo/client";
import { VALORACION_ACCESO_INTEGRO_ID, VALORACION_ACCESO_PERMEABLE_ID } from "../../../../Pages/MisVisitasCreation/constants/valoracionAccesoIds";

const SAVE_VALORACION_AE_DI = gql`
    mutation saveVisitaPresencialAEValoracion($input: AddVisitaPresencialAEValoracionInput!){
        saveVisitaPresencialAEValoracion(input: $input) {
            idPresencialAE
            idVisita
        }
    }
`;

export default SAVE_VALORACION_AE_DI;

export const adaptAddVisitaPresencialAEValoracionInput = (data) => ({
  idPresencialAE: data.idPresencialAE,
  distencion: !!data.distencion,
  constipacion: !!data.constipacion,
  diarrea: !!data.diarrea,
  diuresis: !!data.diuresis,
  cantidad: data.cantidadDiuresis,
  toleranciaTratamiento: !!data.toleranciaTratamiento,
  obsTolerancia: data.obsTolerancia,
  integro: !!data.accesoIntegro,
  permeable: !!data.accesoPermeable,
  cumplimientoIndicacion: !!data.cumplimientoIndicacion,
  obsCumplimientoIndicacion: data.obsCumplimientoIndicacion,
  idVisita: data.idVisita
});